import Toastr from "toastr2";
import qs from "qs"
const toastr = new Toastr()
import URI from "./Uri.js";

const API = new (class {
    get(namespace, method, configuration) {
        const query = qs.stringify(configuration.data)
        const appendQuery = query.length > 0 ? "?" + query : "";
        const uri = URI.getPrefix() + "/newapi/" + encodeURIComponent(namespace) + "/" + encodeURIComponent(method) + appendQuery;
        fetch(uri, {
            method: 'GET',
            headers: {
                "Accept": "application/json"
            },
        }).then(res => res.json()).then(this.processData.bind(this, configuration));
    }
    post(namespace, method, configuration = {}) {
        const uri = URI.getPrefix() + "/newapi/" + encodeURIComponent(namespace) + "/" + encodeURIComponent(method);
        fetch(uri, {
            method: 'POST',
            headers: {
                "Accept": "application/json"
            },
            body: this._getData(configuration.data)
        }).then(res => res.json()).then(this.processData.bind(this, configuration));
    }
    _getData(postData) {
        const data = new FormData();
        if(typeof postData === "object")
            for(var key in postData)
                data.append(key, postData[key])
        return data;
    }
    processData(configuration, data) {
        const configurationKeys = Object.keys(configuration);
        if (data.errors.length > 0) {
            if (configurationKeys.includes("error")) {
                configuration.error(data.errors);
            }
            else {
                data.errors.forEach(function (error) {
                    toastr.error(error.description, error.title);
                });
            }
        } else {
            if (configurationKeys.includes("success")) {
                configuration.success(data.data);
            }
        }
        if(configurationKeys.includes("complete")) {
            configuration.complete();
        }
    }
})

export default API;